import { Outlet } from "react-router-dom";
import Header from './Header';
import Footer from './Footer';

const MainLayout = () => (
  <div className="container-fluid p-0">
    <Header />
      <Outlet />
    <Footer />
  </div>
)


export default MainLayout;
